import { render, staticRenderFns } from "./BzChat.vue?vue&type=template&id=f97ff348&scoped=true&"
import script from "./BzChat.vue?vue&type=script&lang=js&"
export * from "./BzChat.vue?vue&type=script&lang=js&"
import style0 from "./BzChat.vue?vue&type=style&index=0&id=f97ff348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97ff348",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VImg,VRow,VTextField})
